module.exports = __WEBPACK_EXTERNAL_MODULE_https_views_development_pdfcompare_net_shell_remoteEntry_js_7422ae7e__;